(() => {
const moleculeDrawings = [
  {
    bonds: [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 4],
      [4, 0],
      [2, 5],
      [5, 6],
      [6, 7],
      [7, 8],
      [6, 9],
      [9, 10],
      [10, 11],
      [11, 12],
    ],
    nodes: [
      [42, 92, "N"],
      [70, 68, ""],
      [104, 78, "N"],
      [110, 116, ""],
      [72, 126, ""],
      [140, 58, ""],
      [174, 74, "O"],
      [204, 58, ""],
      [232, 78, "P"],
      [176, 112, ""],
      [204, 136, "O"],
      [238, 124, ""],
      [262, 148, "O"],
    ],
  },
  {
    bonds: [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 4],
      [4, 5],
      [5, 6],
      [6, 7],
      [7, 8],
      [8, 9],
      [2, 10],
      [4, 11],
      [6, 12],
      [8, 13],
    ],
    nodes: [
      [26, 110, "O"],
      [58, 90, ""],
      [90, 108, ""],
      [124, 88, ""],
      [158, 106, ""],
      [192, 86, ""],
      [226, 104, ""],
      [260, 84, ""],
      [294, 102, ""],
      [326, 84, "O"],
      [86, 142, ""],
      [156, 142, ""],
      [226, 138, ""],
      [294, 136, ""],
    ],
  },
  {
    bonds: [
      [0, 1],
      [1, 2],
      [1, 3],
      [1, 4],
      [4, 5],
      [5, 6],
      [5, 7],
    ],
    nodes: [
      [66, 86, "O"],
      [116, 112, "N"],
      [116, 62, ""],
      [76, 146, ""],
      [168, 112, ""],
      [218, 112, "O"],
      [252, 82, "O"],
      [252, 142, "O"],
    ],
  },
  {
    bonds: [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 4],
      [4, 5],
      [4, 6],
    ],
    nodes: [
      [54, 106, "N"],
      [96, 86, ""],
      [140, 106, ""],
      [184, 86, ""],
      [226, 106, "S"],
      [272, 88, "O"],
      [272, 126, "O"],
    ],
  },
  {
    bonds: [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 4],
      [4, 5],
      [5, 0],
      [3, 6],
      [6, 7],
      [7, 8],
      [8, 9],
      [9, 10],
      [10, 11],
      [11, 12],
      [12, 7],
    ],
    nodes: [
      [42, 104, ""],
      [62, 70, ""],
      [104, 70, ""],
      [126, 104, ""],
      [104, 138, "O"],
      [62, 138, ""],
      [168, 104, ""],
      [208, 76, ""],
      [250, 76, ""],
      [272, 110, ""],
      [250, 144, "O"],
      [208, 144, ""],
      [186, 110, ""],
    ],
  },
  {
    bonds: [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 4],
      [4, 5],
      [5, 6],
      [6, 7],
      [7, 8],
    ],
    nodes: [
      [44, 106, "N"],
      [78, 86, ""],
      [112, 106, ""],
      [146, 86, "N"],
      [180, 106, ""],
      [214, 86, ""],
      [248, 106, "N"],
      [282, 86, ""],
      [316, 106, ""],
    ],
  },
  {
    bonds: [
      [0, 1],
      [1, 2],
      [2, 3],
      [3, 4],
      [4, 5],
      [5, 6],
      [6, 7],
      [7, 8],
      [8, 9],
      [9, 10],
      [10, 11],
      [11, 12],
      [12, 13],
      [13, 14],
    ],
    nodes: [
      [28, 118, "O"],
      [58, 86, ""],
      [90, 118, ""],
      [122, 86, ""],
      [154, 118, ""],
      [186, 86, ""],
      [218, 118, ""],
      [250, 86, ""],
      [282, 118, ""],
      [314, 86, ""],
      [346, 118, ""],
      [378, 86, ""],
      [410, 118, ""],
      [442, 86, ""],
      [472, 118, "O"],
    ],
  },
];

const moleculeRenderImages = [
  "molecule-nmn.png",
  "molecule-coq10.png",
  "molecule-tmg.png",
  "molecule-taurin.png",
  "molecule-trans-resveratrol.png",
  "molecule-pqq.png",
  "molecule-spermidin.png",
];



const siteNav = document.querySelector(".site-nav");

const legalTocLinks = Array.from(document.querySelectorAll(".legal-toc a[href^='#legal-']"));

if (legalTocLinks.length) {
  const syncLegalTocActiveState = () => {
    const activeHash = window.location.hash;

    legalTocLinks.forEach((link) => {
      const isActive = link.getAttribute("href") === activeHash;
      link.classList.toggle("is-active", isActive);

      if (isActive) {
        link.setAttribute("aria-current", "location");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  };

  syncLegalTocActiveState();
  window.addEventListener("hashchange", syncLegalTocActiveState);
}

document.querySelectorAll("[data-trust-slider]").forEach((slider) => {
  const items = Array.from(slider.children);
  const mobileQuery = window.matchMedia("(max-width: 760px)");
  const reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  let activeIndex = 0;
  let intervalId = 0;
  let transitionTimeout = 0;

  const showItem = (nextIndex) => {
    const previousIndex = activeIndex;
    activeIndex = nextIndex;

    window.clearTimeout(transitionTimeout);
    items.forEach((item, index) => {
      item.classList.toggle("is-active", index === activeIndex);
      item.classList.toggle("is-leaving", index === previousIndex && previousIndex !== activeIndex);
      item.setAttribute("aria-hidden", String(index !== activeIndex));
    });

    transitionTimeout = window.setTimeout(() => {
      items[previousIndex]?.classList.remove("is-leaving");
    }, 520);
  };

  const syncTrustSlider = () => {
    window.clearInterval(intervalId);
    window.clearTimeout(transitionTimeout);

    if (!mobileQuery.matches) {
      items.forEach((item) => {
        item.classList.remove("is-active", "is-leaving");
        item.removeAttribute("aria-hidden");
      });
      return;
    }

    showItem(activeIndex % items.length);

    if (!reducedMotionQuery.matches && !document.hidden && items.length > 1) {
      intervalId = window.setInterval(() => {
        showItem((activeIndex + 1) % items.length);
      }, 2800);
    }
  };

  mobileQuery.addEventListener?.("change", syncTrustSlider);
  reducedMotionQuery.addEventListener?.("change", syncTrustSlider);
  document.addEventListener("visibilitychange", syncTrustSlider);
  syncTrustSlider();
});

document.querySelectorAll("[data-program-form]").forEach((form) => {
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    const status = form.querySelector(".program-form-status");
    if (status) status.hidden = false;
  });
});

const setupMobileMenu = () => {
  if (!siteNav || siteNav.querySelector(".mobile-menu-toggle")) return;

  const navLinks = siteNav.querySelector(".nav-links");
  const loginLink = siteNav.querySelector(".login-link");
  if (!navLinks) return;

  const toggle = document.createElement("button");
  toggle.className = "mobile-menu-toggle";
  toggle.type = "button";
  toggle.setAttribute("aria-label", "Men\u00fc \u00f6ffnen");
  toggle.setAttribute("aria-expanded", "false");
  toggle.innerHTML = "<span></span><span></span><span></span>";
  siteNav.prepend(toggle);

  if (loginLink && !navLinks.querySelector(".mobile-login-link")) {
    const mobileLogin = loginLink.cloneNode(true);
    mobileLogin.classList.add("mobile-login-link");
    navLinks.append(mobileLogin);
  }

  const setOpen = (isOpen) => {
    siteNav.classList.toggle("is-menu-open", isOpen);
    toggle.setAttribute("aria-expanded", String(isOpen));
    toggle.setAttribute("aria-label", isOpen ? "Men\u00fc schlie\u00dfen" : "Men\u00fc \u00f6ffnen");
  };

  toggle.addEventListener("click", () => {
    setOpen(!siteNav.classList.contains("is-menu-open"));
  });

  navLinks.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => setOpen(false));
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setOpen(false);
    }
  });

  window.addEventListener(
    "resize",
    () => {
      if (window.innerWidth > 760) {
        setOpen(false);
      }
    },
    { passive: true },
  );
};

setupMobileMenu();

let lastScrollY = window.scrollY;

const updateNavSurface = () => {
  if (!siteNav) return;

  const currentScrollY = Math.max(window.scrollY, 0);
  const isScrollingDown = currentScrollY > lastScrollY + 6;
  const isScrollingUp = currentScrollY < lastScrollY - 6;
  const shouldHide =
    currentScrollY > 120 && isScrollingDown && !siteNav.classList.contains("is-menu-open");

  siteNav.classList.toggle("is-scrolled", currentScrollY > 24);

  if (shouldHide) {
    siteNav.classList.add("is-hidden");
  } else if (isScrollingUp || currentScrollY <= 24) {
    siteNav.classList.remove("is-hidden");
  }

  document.documentElement.classList.toggle("nav-is-hidden", siteNav.classList.contains("is-hidden"));
  lastScrollY = currentScrollY;
};

updateNavSurface();
window.addEventListener("scroll", updateNavSurface, { passive: true });

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const easeOutQuart = (progress) => 1 - Math.pow(1 - progress, 4);
const activeScrollAnimations = new WeakMap();

const smoothScrollElementTo = (element, targetLeft, duration = 520) => {
  if (!element) return;

  const maxScrollLeft = Math.max(0, element.scrollWidth - element.clientWidth);
  const nextLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));
  const runningAnimation = activeScrollAnimations.get(element);

  if (runningAnimation) {
    runningAnimation.cancelled = true;
    cancelAnimationFrame(runningAnimation.frameId);
  }

  if (prefersReducedMotion) {
    element.scrollLeft = nextLeft;
    return;
  }

  const startLeft = element.scrollLeft;
  const distance = nextLeft - startLeft;

  if (Math.abs(distance) < 1) {
    element.scrollLeft = nextLeft;
    return;
  }

  const scrollDuration = Math.min(Math.max(duration, 320), 620);
  const startTime = performance.now();
  const animation = { cancelled: false, frameId: 0 };

  element.classList.add("is-programmatic-scroll");

  const animate = (now) => {
    if (animation.cancelled) return;

    const elapsed = now - startTime;
    const progress = Math.min(elapsed / scrollDuration, 1);

    element.scrollLeft = startLeft + distance * easeOutQuart(progress);

    if (progress < 1) {
      animation.frameId = requestAnimationFrame(animate);
      activeScrollAnimations.set(element, animation);
      return;
    }

    element.scrollLeft = nextLeft;
    activeScrollAnimations.delete(element);

    requestAnimationFrame(() => {
      if (!activeScrollAnimations.has(element)) {
        element.classList.remove("is-programmatic-scroll");
      }
    });
  };

  animation.frameId = requestAnimationFrame(animate);
  activeScrollAnimations.set(element, animation);
};

const enableDragScroll = (element, { onDragEnd } = {}) => {
  if (!element) return;

  let isDragging = false;
  let startX = 0;
  let startScrollLeft = 0;
  let hasMoved = false;

  const stopRunningAnimation = () => {
    const runningAnimation = activeScrollAnimations.get(element);
    if (!runningAnimation) return;

    runningAnimation.cancelled = true;
    cancelAnimationFrame(runningAnimation.frameId);
    activeScrollAnimations.delete(element);
  };

  element.classList.add("is-draggable-scroll");

  element.addEventListener("pointerdown", (event) => {
    if (event.button !== 0 || event.pointerType === "touch") return;
    if (event.target.closest("a, button, input, textarea, select, summary")) return;

    stopRunningAnimation();
    isDragging = true;
    hasMoved = false;
    startX = event.clientX;
    startScrollLeft = element.scrollLeft;
    element.classList.add("is-dragging", "is-programmatic-scroll");
    element.setPointerCapture?.(event.pointerId);
  });

  element.addEventListener("pointermove", (event) => {
    if (!isDragging) return;

    const distance = event.clientX - startX;
    if (Math.abs(distance) > 3) {
      hasMoved = true;
    }

    element.scrollLeft = startScrollLeft - distance;
    event.preventDefault();
  });

  const finishDrag = (event) => {
    if (!isDragging) return;

    isDragging = false;
    element.releasePointerCapture?.(event.pointerId);
    element.classList.remove("is-dragging");

    window.setTimeout(() => {
      element.classList.remove("is-programmatic-scroll");
      onDragEnd?.();
    }, 80);
  };

  element.addEventListener("pointerup", finishDrag);
  element.addEventListener("pointercancel", finishDrag);
  element.addEventListener("lostpointercapture", () => {
    if (!isDragging) return;

    isDragging = false;
    element.classList.remove("is-dragging");
    window.setTimeout(() => {
      element.classList.remove("is-programmatic-scroll");
      onDragEnd?.();
    }, 80);
  });

  element.addEventListener(
    "click",
    (event) => {
      if (!hasMoved) return;

      event.preventDefault();
      event.stopPropagation();
      hasMoved = false;
    },
    true,
  );
};

const initMoleculeCanvases = () => {
  const canvases = Array.from(document.querySelectorAll(".ingredient-molecule-canvas"));
  if (!canvases.length) return;

  canvases.forEach((canvas) => {
    if (canvas.dataset.moleculeReady === "true") return;
    canvas.dataset.moleculeReady = "true";

    const context = canvas.getContext("2d");
    const drawingIndex = Number(canvas.dataset.moleculeIndex || 0);
    const variant = Number(canvas.dataset.moleculeVariant || 0);
    const drawing = moleculeDrawings[drawingIndex % moleculeDrawings.length];
    const sourceWidth = drawingIndex === 6 ? 500 : 350;
    const sourceHeight = 210;
    const card = canvas.closest(".ingredient-showcase-card");
    let width = 0;
    let height = 0;
    let rotation = -0.65 + (variant % 3) * 0.24;
    let spinSpeed = 0;
    let isHovering = false;
    let animationFrame = null;

    const points3d = drawing.nodes.map(([x, y, label], nodeIndex) => ({
      label,
      x: x - sourceWidth / 2,
      y: y - sourceHeight / 2,
      z:
        Math.sin(x * 0.052 + variant * 0.9) * 46 +
        Math.cos(y * 0.071 + nodeIndex * 0.68) * 32,
    }));

    const resizeCanvas = () => {
      const rect = canvas.getBoundingClientRect();
      const nextWidth = Math.max(1, rect.width);
      const nextHeight = Math.max(1, rect.height);
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);

      width = nextWidth;
      height = nextHeight;
      canvas.width = Math.round(nextWidth * pixelRatio);
      canvas.height = Math.round(nextHeight * pixelRatio);
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      draw();
    };

    const projectPoint = (point) => {
      const scaleByBounds = Math.min(
        width / (sourceWidth * (drawingIndex === 6 ? 0.9 : 0.72)),
        height / 170,
      );
      const worldX = point.x * scaleByBounds;
      const worldY = point.y * scaleByBounds;
      const worldZ = point.z * scaleByBounds;
      const rotateX = 0.26;
      const cosY = Math.cos(rotation);
      const sinY = Math.sin(rotation);
      const cosX = Math.cos(rotateX);
      const sinX = Math.sin(rotateX);
      const x1 = worldX * cosY + worldZ * sinY;
      const z1 = -worldX * sinY + worldZ * cosY;
      const y1 = worldY * cosX - z1 * sinX;
      const z2 = worldY * sinX + z1 * cosX;
      const perspective = Math.max(430, width * 1.45);
      const perspectiveScale = perspective / (perspective - z2);

      return {
        ...point,
        x: width / 2 + x1 * perspectiveScale,
        y: height / 2 + y1 * perspectiveScale,
        z: z2,
        scale: perspectiveScale,
      };
    };

    const lineBetween = (start, end, widthValue, color, alpha = 1) => {
      context.globalAlpha = alpha;
      context.strokeStyle = color;
      context.lineWidth = widthValue;
      context.lineCap = "round";
      context.beginPath();
      context.moveTo(start.x, start.y);
      context.lineTo(end.x, end.y);
      context.stroke();
      context.globalAlpha = 1;
    };

    const drawBond = (bond, points, depthRange) => {
      const [from, to] = bond;
      const start = points[from];
      const end = points[to];
      const depth = (((start.z + end.z) / 2) - depthRange.min) / depthRange.range;
      const lineWidth = 4.5 + depth * 4.2;

      lineBetween(
        { x: start.x + 3.4, y: start.y + 4.2 },
        { x: end.x + 3.4, y: end.y + 4.2 },
        lineWidth + 5,
        "rgba(24, 24, 25, 0.14)",
        0.85,
      );
      lineBetween(start, end, lineWidth + 2.5, "rgba(24, 24, 25, 0.88)", 0.95);
      lineBetween(start, end, lineWidth, "rgba(226, 182, 62, 0.95)", 0.96);
      lineBetween(
        { x: start.x - 0.4, y: start.y - lineWidth * 0.28 },
        { x: end.x - 0.4, y: end.y - lineWidth * 0.28 },
        Math.max(1.1, lineWidth * 0.22),
        "rgba(250, 247, 239, 0.58)",
        0.72,
      );
    };

    const drawAtom = (point, depthRange) => {
      const depth = (point.z - depthRange.min) / depthRange.range;
      const baseRadius = point.label ? 15 : 10.5;
      const radius = baseRadius * (0.82 + depth * 0.5) * point.scale;
      const shadowRadius = radius * 1.1;
      const isLabelAtom = Boolean(point.label);

      context.save();
      context.translate(point.x, point.y);

      context.globalAlpha = 0.22 + depth * 0.18;
      context.fillStyle = "rgba(24, 24, 25, 0.35)";
      context.beginPath();
      context.ellipse(radius * 0.26, radius * 0.5, shadowRadius, radius * 0.38, 0, 0, Math.PI * 2);
      context.fill();
      context.globalAlpha = 1;

      const gradient = context.createRadialGradient(
        -radius * 0.36,
        -radius * 0.38,
        radius * 0.12,
        0,
        0,
        radius * 1.18,
      );

      if (isLabelAtom) {
        gradient.addColorStop(0, "#FFFFFF");
        gradient.addColorStop(0.48, "#FFFFFF");
        gradient.addColorStop(1, "#E2B63E");
      } else {
        gradient.addColorStop(0, "#E2B63E");
        gradient.addColorStop(0.5, "#E2B63E");
        gradient.addColorStop(1, "#181819");
      }

      context.fillStyle = gradient;
      context.strokeStyle = depth > 0.58 ? "rgba(24, 24, 25, 0.96)" : "rgba(24, 24, 25, 0.66)";
      context.lineWidth = isLabelAtom ? 2.2 : 1.4;
      context.beginPath();
      context.arc(0, 0, radius, 0, Math.PI * 2);
      context.fill();
      context.stroke();

      context.fillStyle = "rgba(255, 255, 255, 0.86)";
      context.beginPath();
      context.arc(-radius * 0.35, -radius * 0.42, radius * 0.24, 0, Math.PI * 2);
      context.fill();

      if (point.label) {
        context.fillStyle = "#181819";
        context.font = `700 ${Math.max(10, radius * 0.85)}px "Vista Sans Nar OTCE", Arial, sans-serif`;
        context.textAlign = "center";
        context.textBaseline = "middle";
        context.fillText(point.label, 0, radius * 0.04);
      }

      context.restore();
    };

    const draw = () => {
      if (!width || !height) return;

      context.clearRect(0, 0, width, height);

      const projected = points3d.map(projectPoint);
      const zValues = projected.map((point) => point.z);
      const depthRange = {
        min: Math.min(...zValues),
        range: Math.max(1, Math.max(...zValues) - Math.min(...zValues)),
      };
      const layers = [
        ...drawing.bonds.map((bond) => ({
          type: "bond",
          z: (projected[bond[0]].z + projected[bond[1]].z) / 2 - 0.01,
          bond,
        })),
        ...projected.map((point) => ({ type: "atom", z: point.z, point })),
      ].sort((a, b) => a.z - b.z);

      layers.forEach((layer) => {
        if (layer.type === "bond") {
          drawBond(layer.bond, projected, depthRange);
        } else {
          drawAtom(layer.point, depthRange);
        }
      });
    };

    const tick = () => {
      const targetSpeed = isHovering && !prefersReducedMotion ? 0.018 : 0;
      spinSpeed += (targetSpeed - spinSpeed) * 0.085;
      rotation += spinSpeed;
      draw();

      if (isHovering || Math.abs(spinSpeed) > 0.0005) {
        animationFrame = requestAnimationFrame(tick);
      } else {
        animationFrame = null;
      }
    };

    const startAnimation = () => {
      if (!animationFrame) {
        animationFrame = requestAnimationFrame(tick);
      }
    };

    card?.addEventListener("pointerenter", () => {
      isHovering = true;
      startAnimation();
    });
    card?.addEventListener("pointerleave", () => {
      isHovering = false;
      startAnimation();
    });
    card?.addEventListener("focusin", () => {
      isHovering = true;
      startAnimation();
    });
    card?.addEventListener("focusout", () => {
      isHovering = false;
      startAnimation();
    });

    if ("ResizeObserver" in window) {
      const observer = new ResizeObserver(resizeCanvas);
      observer.observe(canvas);
    } else {
      window.addEventListener("resize", resizeCanvas, { passive: true });
    }

    resizeCanvas();
  });
};

document.querySelectorAll("[data-dosage-finder]").forEach((finder) => {
  const options = Array.from(finder.querySelectorAll("[data-dosage-option]"));
  const steps = Array.from(finder.querySelectorAll("[data-dosage-step]"));
  const result = finder.querySelector("[data-dosage-result]");
  const progress = finder.querySelector("[data-dosage-progress]");
  const backButton = finder.querySelector("[data-dosage-back]");
  const restartButton = finder.querySelector("[data-dosage-restart]");
  const resultTitle = finder.querySelector("[data-dosage-result-title]");
  const resultCopy = finder.querySelector("[data-dosage-result-copy]");
  const resultNote = finder.querySelector("[data-dosage-result-note]");
  const dosageRows = Array.from(document.querySelectorAll("[data-dosage-row]"));
  let activeStep = 0;
  let isShowingResult = false;

  const recommendations = {
    gentle: {
      title: "Gentle",
      copy: "1 Kapsel NMN + 1 Kapsel NMN Optimizer t\u00e4glich.",
      note: "Reicht ca. 60 Tage pro Bundle.",
    },
    standard: {
      title: "Standard",
      copy: "2 Kapseln NMN + 2 Kapseln NMN Optimizer t\u00e4glich.",
      note: "Reicht ca. 30 Tage pro Bundle.",
    },
    advanced: {
      title: "Advanced",
      copy: "3 Kapseln NMN + 3 Kapseln NMN Optimizer t\u00e4glich.",
      note: "Reicht ca. 20 Tage pro Bundle.",
    },
  };

  const getRecommendationKey = () => {
    const selectedOptions = options.filter((option) => option.classList.contains("is-selected"));
    const score = selectedOptions.reduce(
      (total, option) => total + Number(option.dataset.dosageScore || 0),
      0,
    );

    if (score <= -2) return "gentle";
    if (score >= 2) return "advanced";
    return "standard";
  };

  const updateDosageFinder = () => {
    const recommendationKey = getRecommendationKey();
    const recommendation = recommendations[recommendationKey];

    if (resultTitle) resultTitle.textContent = recommendation.title;
    if (resultCopy) resultCopy.textContent = recommendation.copy;
    if (resultNote) resultNote.textContent = recommendation.note;

    dosageRows.forEach((row) => {
      row.classList.toggle("is-finder-match", row.dataset.dosageRow === recommendationKey);
    });
  };

  const updateDosageStep = () => {
    steps.forEach((step, index) => {
      const isActive = !isShowingResult && index === activeStep;
      step.hidden = !isActive;
      step.classList.toggle("is-active", isActive);
    });

    if (result) result.hidden = !isShowingResult;
    finder.classList.toggle("is-result", isShowingResult);

    if (progress) {
      progress.textContent = isShowingResult ? "Ergebnis" : `${activeStep + 1}/${steps.length}`;
    }

    if (backButton) {
      backButton.disabled = activeStep === 0 && !isShowingResult;
    }

    if (restartButton) {
      restartButton.hidden = !isShowingResult;
    }
  };

  const showResult = () => {
    isShowingResult = true;
    updateDosageFinder();
    updateDosageStep();
  };

  options.forEach((option) => {
    option.setAttribute("aria-pressed", "false");

    option.addEventListener("click", () => {
      const groupOptions = options.filter(
        (item) => item.dataset.dosageQuestion === option.dataset.dosageQuestion,
      );

      groupOptions.forEach((item) => {
        const isSelected = item === option;
        item.classList.toggle("is-selected", isSelected);
        item.setAttribute("aria-pressed", isSelected ? "true" : "false");
      });

      if (activeStep < steps.length - 1) {
        activeStep += 1;
        isShowingResult = false;
        updateDosageStep();
        return;
      }

      showResult();
    });
  });

  backButton?.addEventListener("click", () => {
    if (isShowingResult) {
      isShowingResult = false;
      activeStep = steps.length - 1;
      updateDosageStep();
      return;
    }

    activeStep = Math.max(0, activeStep - 1);
    updateDosageStep();
  });

  restartButton?.addEventListener("click", () => {
    activeStep = 0;
    isShowingResult = false;
    options.forEach((option) => {
      option.classList.remove("is-selected");
      option.setAttribute("aria-pressed", "false");
    });
    dosageRows.forEach((row) => {
      row.classList.toggle("is-finder-match", row.dataset.dosageRow === "standard");
    });
    updateDosageStep();
  });

  dosageRows.forEach((row) => {
    row.classList.toggle("is-finder-match", row.dataset.dosageRow === "standard");
  });
  updateDosageStep();
});

document.querySelectorAll("[data-product-gallery]").forEach((gallery) => {
  const galleryWrap = gallery.closest(".product-gallery");
  const track = gallery.querySelector(".product-gallery-track");
  const realSlides = Array.from(gallery.querySelectorAll(".product-gallery-slide"));
  const dots = Array.from(gallery.querySelectorAll("[data-gallery-dot]"));
  const thumbs = Array.from(galleryWrap?.querySelectorAll("[data-gallery-thumb]") ?? []);
  const prev = gallery.querySelector("[data-gallery-prev]");
  const next = gallery.querySelector("[data-gallery-next]");

  if (!track || realSlides.length === 0) return;

  const firstClone = realSlides[0].cloneNode(true);
  const lastClone = realSlides.at(-1).cloneNode(true);
  firstClone.dataset.galleryClone = "first";
  lastClone.dataset.galleryClone = "last";
  firstClone.setAttribute("aria-hidden", "true");
  lastClone.setAttribute("aria-hidden", "true");
  track.prepend(lastClone);
  track.append(firstClone);

  const slides = [lastClone, ...realSlides, firstClone];
  const realSlideCount = realSlides.length;
  let edgeResetTimer = 0;

  const getPhysicalIndex = () =>
    slides.reduce(
      (closest, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
        return distance < closest.distance ? { index, distance } : closest;
      },
      { index: 1, distance: Infinity },
    ).index;

  const toRealIndex = (physicalIndex) =>
    ((physicalIndex - 1) % realSlideCount + realSlideCount) % realSlideCount;

  const getActiveIndex = () => toRealIndex(getPhysicalIndex());

  const jumpToPhysicalSlide = (physicalIndex) => {
    track.classList.add("is-programmatic-scroll");
    track.scrollLeft = slides[physicalIndex].offsetLeft;
    requestAnimationFrame(() => track.classList.remove("is-programmatic-scroll"));
  };

  const resetEdgeClone = () => {
    const physicalIndex = getPhysicalIndex();
    if (physicalIndex === 0) jumpToPhysicalSlide(realSlideCount);
    if (physicalIndex === slides.length - 1) jumpToPhysicalSlide(1);
    updateGalleryState();
  };

  const updateGalleryState = () => {
    const activeIndex = getActiveIndex();

    dots.forEach((dot, index) => {
      dot.classList.toggle("is-active", index === activeIndex);
      dot.setAttribute("aria-current", index === activeIndex ? "true" : "false");
    });

    thumbs.forEach((thumb) => {
      const index = Number(thumb.dataset.galleryThumb);
      const isActive = index === activeIndex;
      thumb.classList.toggle("is-active", isActive);
      thumb.setAttribute("aria-current", isActive ? "true" : "false");
    });

    prev?.removeAttribute("disabled");
    next?.removeAttribute("disabled");
  };

  const goToPhysicalSlide = (physicalIndex) => {
    const boundedIndex = Math.max(0, Math.min(slides.length - 1, physicalIndex));
    window.clearTimeout(edgeResetTimer);
    smoothScrollElementTo(track, slides[boundedIndex].offsetLeft, 640);
    edgeResetTimer = window.setTimeout(resetEdgeClone, prefersReducedMotion ? 0 : 660);
  };

  const moveBy = (direction) => {
    const physicalIndex = getPhysicalIndex();
    const normalizedPhysicalIndex =
      physicalIndex === 0
        ? realSlideCount
        : physicalIndex === slides.length - 1
          ? 1
          : physicalIndex;
    if (normalizedPhysicalIndex !== physicalIndex) jumpToPhysicalSlide(normalizedPhysicalIndex);
    goToPhysicalSlide(normalizedPhysicalIndex + direction);
  };

  prev?.addEventListener("click", () => moveBy(-1));
  next?.addEventListener("click", () => moveBy(1));
  dots.forEach((dot, index) => {
    dot.addEventListener("click", () => goToPhysicalSlide(index + 1));
  });
  thumbs.forEach((thumb) => {
    thumb.addEventListener("click", () => goToPhysicalSlide(Number(thumb.dataset.galleryThumb) + 1));
  });

  enableDragScroll(track, {
    onDragEnd: () => {
      updateGalleryState();
      resetEdgeClone();
    },
  });
  track.addEventListener("scroll", updateGalleryState, { passive: true });
  window.addEventListener(
    "resize",
    () => {
      jumpToPhysicalSlide(getActiveIndex() + 1);
      updateGalleryState();
    },
    { passive: true },
  );
  jumpToPhysicalSlide(1);
  updateGalleryState();
});

const setupSlidingTopicNav = ({ navSelector, sectionSelector, variablePrefix }) => {
  const topicNav = document.querySelector(navSelector);
  const topicLinks = Array.from(document.querySelectorAll(`${navSelector} a`));
  const topicSections = Array.from(document.querySelectorAll(sectionSelector));
  let activeTopicId = "";

  const updateTopicIndicator = (activeLink) => {
    if (!topicNav || !activeLink) return;

    topicNav.style.setProperty(`--${variablePrefix}-pill-left`, `${activeLink.offsetLeft}px`);
    topicNav.style.setProperty(`--${variablePrefix}-pill-width`, `${activeLink.offsetWidth}px`);
    topicNav.style.setProperty(`--${variablePrefix}-pill-height`, `${activeLink.offsetHeight}px`);
    topicNav.style.setProperty(`--${variablePrefix}-pill-opacity`, "1");
  };

  const revealActiveTopicLink = (activeLink) => {
    const scroller = activeLink?.parentElement;
    if (!scroller || scroller.scrollWidth <= scroller.clientWidth) return;

    const targetLeft = activeLink.offsetLeft - (scroller.clientWidth - activeLink.offsetWidth) / 2;
    const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
    const nextLeft = Math.max(0, Math.min(targetLeft, maxScrollLeft));

    scroller.scrollTo({
      left: nextLeft,
      behavior: prefersReducedMotion ? "auto" : "smooth",
    });
  };

  const setActiveTopic = (sectionId) => {
    if (!topicNav) return;

    const activeLink = topicLinks.find((link) => link.getAttribute("href") === `#${sectionId}`);
    if (!activeLink) return;

    const didChange = activeTopicId !== sectionId;
    activeTopicId = sectionId;
    topicLinks.forEach((link) => link.classList.toggle("is-active", link === activeLink));
    updateTopicIndicator(activeLink);
    if (didChange) {
      revealActiveTopicLink(activeLink);
    }
  };

  const updateTopicNav = () => {
    if (!topicSections.length) return;

    const marker = Math.min(window.innerHeight * 0.38, 360);
    let activeSection = topicSections[0];

    topicSections.forEach((section) => {
      if (section.getBoundingClientRect().top <= marker) {
        activeSection = section;
      }
    });

    setActiveTopic(activeSection.id);
  };

  if (topicNav && topicSections.length) {
    updateTopicNav();
    window.addEventListener("scroll", updateTopicNav, { passive: true });
    window.addEventListener(
      "resize",
      () => {
        const activeLink = topicLinks.find((link) => link.classList.contains("is-active"));
        updateTopicIndicator(activeLink);
      },
      { passive: true },
    );
  }
};

setupSlidingTopicNav({
  navSelector: ".product-anchor-nav",
  sectionSelector:
    "#pdp-daily-energy, #pdp-science, #pdp-science-explained, #pdp-ingredients, #pdp-quality, #pdp-faq",
  variablePrefix: "product",
});

setupSlidingTopicNav({
  navSelector: ".faq-topic-nav",
  sectionSelector: ".faq-topic-section",
  variablePrefix: "faq",
});

setupSlidingTopicNav({
  navSelector: ".wissen-topic-nav",
  sectionSelector: ".wissen-content-section",
  variablePrefix: "wissen",
});

const setupArticleToc = () => {
  const tocLinks = Array.from(document.querySelectorAll(".wissen-article-toc a"));
  if (!tocLinks.length) return;
  let activeTocId = "";

  const tocSections = tocLinks
    .map((link) => document.querySelector(link.getAttribute("href")))
    .filter(Boolean);

  const setActiveTocLink = (sectionId) => {
    const activeLink = tocLinks.find((link) => link.getAttribute("href") === `#${sectionId}`);
    if (!activeLink) return;

    tocLinks.forEach((link) => {
      link.classList.toggle("is-active", link === activeLink);
    });

    if (activeTocId !== sectionId) {
      const scroller = activeLink.parentElement;
      if (scroller && scroller.scrollWidth > scroller.clientWidth) {
        const targetLeft = activeLink.offsetLeft - (scroller.clientWidth - activeLink.offsetWidth) / 2;
        const maxScrollLeft = scroller.scrollWidth - scroller.clientWidth;
        scroller.scrollTo({
          left: Math.max(0, Math.min(targetLeft, maxScrollLeft)),
          behavior: prefersReducedMotion ? "auto" : "smooth",
        });
      }
    }

    activeTocId = sectionId;
  };

  const updateArticleToc = () => {
    const marker = Math.min(window.innerHeight * 0.34, 320);
    let activeSection = tocSections[0];

    tocSections.forEach((section) => {
      if (section.getBoundingClientRect().top <= marker) {
        activeSection = section;
      }
    });

    if (activeSection) {
      setActiveTocLink(activeSection.id);
    }
  };

  updateArticleToc();
  window.addEventListener("scroll", updateArticleToc, { passive: true });
};

setupArticleToc();

const createPingPongVideo = (video) => {
  let isActive = false;
  let isReverse = false;
  let playRequestId = 0;

  const toAbsoluteVideoSrc = (src) => new URL(src, window.location.href).href;
  const forwardSrc = toAbsoluteVideoSrc(video.getAttribute("src") || video.currentSrc);
  const reverseSrc = toAbsoluteVideoSrc(
    video.dataset.reverseSrc || forwardSrc.replace(/\.mp4(\?.*)?$/i, "-reverse.mp4$1"),
  );

  const reversePreload = document.createElement("video");
  reversePreload.src = reverseSrc;
  reversePreload.muted = true;
  reversePreload.playsInline = true;
  reversePreload.preload = "auto";
  reversePreload.load();

  video.loop = false;

  const resetTime = () => {
    try {
      video.currentTime = 0;
    } catch {}
  };

  const setSource = (src) => {
    const playbackRate = video.playbackRate || 1;
    if (video.currentSrc !== src && video.src !== src) {
      video.src = src;
      video.load();
    }
    video.playbackRate = playbackRate;
  };

  const playSource = (src, { restart = true } = {}) => {
    const requestId = ++playRequestId;
    setSource(src);

    if (restart) {
      resetTime();
    }

    const play = () => {
      if (!isActive || requestId !== playRequestId) return;
      video.play().catch(() => {});
    };

    if (video.readyState >= 2) {
      play();
    } else {
      video.addEventListener("canplay", play, { once: true });
    }
  };

  const playNextDirection = () => {
    if (!isActive) return;

    isReverse = !isReverse;
    playSource(isReverse ? reverseSrc : forwardSrc);
  };

  const playForward = ({ restart = false } = {}) => {
    isActive = true;
    isReverse = false;
    video.loop = false;
    playSource(forwardSrc, { restart });
  };

  const stop = ({ reset = false } = {}) => {
    isActive = false;
    isReverse = false;
    playRequestId += 1;
    video.pause();
    setSource(forwardSrc);

    if (reset) {
      resetTime();
    }
  };

  video.addEventListener("ended", playNextDirection);
  video.addEventListener("loadedmetadata", () => {
    video.loop = false;
  });

  return { playForward, stop };
};

const formulaVideoAutoplayQuery = window.matchMedia("(hover: none), (pointer: coarse), (max-width: 760px)");

document.querySelectorAll("[data-loop-video]").forEach((video) => {
  const formulaCard = video.closest(".bundle-formula-card");
  const pingPongVideo = createPingPongVideo(video);

  video.playbackRate = 1.55;

  if (!formulaCard || prefersReducedMotion) {
    return;
  }

  let isVisible = false;
  const isMobileAutoplay = () => formulaVideoAutoplayQuery.matches;
  const play = ({ restart = true } = {}) => pingPongVideo.playForward({ restart });
  const stop = () => pingPongVideo.stop();
  const updateMobileAutoplay = () => {
    if (!isMobileAutoplay()) {
      stop();
      return;
    }

    if (isVisible) {
      play({ restart: false });
    } else {
      stop();
    }
  };

  if ("IntersectionObserver" in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        isVisible = entry?.isIntersecting ?? false;
        updateMobileAutoplay();
      },
      { threshold: 0.35 },
    );
    observer.observe(formulaCard);
  } else {
    isVisible = true;
    updateMobileAutoplay();
  }

  formulaVideoAutoplayQuery.addEventListener?.("change", updateMobileAutoplay);

  formulaCard.addEventListener("pointerenter", () => {
    if (!isMobileAutoplay()) play({ restart: true });
  });
  formulaCard.addEventListener("pointerleave", () => {
    if (!isMobileAutoplay()) stop();
  });
  formulaCard.addEventListener("focusin", () => {
    if (!isMobileAutoplay()) play({ restart: true });
  });
  formulaCard.addEventListener("focusout", () => {
    if (!isMobileAutoplay()) stop();
  });
});


document.querySelectorAll("[data-system-switcher]").forEach((switcher) => {
  const tabs = Array.from(switcher.querySelectorAll("[data-system-tab]"));
  const panels = Array.from(switcher.querySelectorAll("[data-system-panel]"));
  const videoControls = new WeakMap();

  panels.forEach((panel) => {
    const video = panel.querySelector("video");
    if (video) {
      videoControls.set(video, createPingPongVideo(video));
    }
  });

  const setActiveSystemPanel = (targetKey) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.systemTab === targetKey;
      tab.classList.toggle("is-active", isActive);
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.systemPanel === targetKey;
      const video = panel.querySelector("video");

      panel.hidden = !isActive;
      panel.classList.toggle("is-active", isActive);

      if (!video) return;
      const pingPongVideo = videoControls.get(video);

      if (isActive) {
        if (!prefersReducedMotion) {
          pingPongVideo?.playForward({ restart: true });
        }
      } else {
        pingPongVideo?.stop({ reset: true });
      }
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => setActiveSystemPanel(tab.dataset.systemTab));
  });

  setActiveSystemPanel(tabs.find((tab) => tab.classList.contains("is-active"))?.dataset.systemTab || "nmn");
});

const updateStickyProductCta = ({ price, label, savings } = {}) => {
  const stickyPrice = document.querySelector("[data-sticky-price]");
  const stickyLabel = document.querySelector("[data-sticky-label]");
  const stickySavings = document.querySelector("[data-sticky-savings]");
  const stickyChoices = Array.from(document.querySelectorAll("[data-sticky-purchase-choice]"));

  if (stickyPrice && price) {
    stickyPrice.textContent = price;
  }

  if (stickyLabel && label) {
    stickyLabel.textContent = label;
  }

  if (stickySavings) {
    stickySavings.textContent = savings || "";
    stickySavings.hidden = !savings;
  }

  if (stickyChoices.length && label) {
    stickyChoices.forEach((choice) => {
      const isActive = choice.dataset.buyLabel === label;
      choice.classList.toggle("is-active", isActive);
      choice.setAttribute("aria-checked", isActive ? "true" : "false");
    });
  }
};

document.querySelectorAll("[data-buy-box]").forEach((box) => {
  const options = Array.from(box.querySelectorAll("[data-buy-option]"));
  const tiers = Array.from(box.querySelectorAll("[data-buy-tier]"));
  const cta = box.querySelector("[data-buy-cta]");
  const savingsBadges = Array.from(box.querySelectorAll("[data-buy-savings-badge]"));

  const setActivePurchase = (target) => {
    const option = target.closest("[data-buy-option]");
    if (!option) return;

    const selectedTier = target.matches("[data-buy-tier]")
      ? target
      : option.querySelector("[data-buy-tier].is-active") || option.querySelector("[data-buy-tier]");
    const selected = selectedTier || target;
    const price = selected.dataset.buyPrice || option.dataset.buyPrice;
    const label = selected.dataset.buyLabel || option.dataset.buyLabel;
    const total = selected.dataset.buyTotal || option.dataset.buyTotal || "";
    const savings = selectedTier?.dataset.buySavings || selected.dataset.buySavings || option.dataset.buySavings || "";
    const quantityByLabel = { "1 Bundle": "1", "ab 3 Bundles": "3", "ab 6 Bundles": "6", "Abo": "1" };
    const purchaseForm = box.closest("form");
    const variantInput = purchaseForm?.querySelector("[data-buy-variant-input]");
    const quantityInput = purchaseForm?.querySelector("[data-buy-quantity-input]");
    const sellingPlanInput = purchaseForm?.querySelector("[data-buy-selling-plan-input]");
    const quantity = selected.dataset.buyQuantity || option.dataset.buyQuantity || quantityByLabel[label] || "1";
    const sellingPlan = selected.dataset.buySellingPlan || option.dataset.buySellingPlan || "";
    const variant = selected.dataset.buyVariant || option.dataset.buyVariant || "";
    const available = (selected.dataset.buyAvailable || option.dataset.buyAvailable || "true") !== "false";

    if (variantInput && variant) {
      variantInput.value = variant;
    }

    if (quantityInput) {
      quantityInput.value = quantity;
    }

    if (sellingPlanInput) {
      sellingPlanInput.value = sellingPlan;
      sellingPlanInput.disabled = !sellingPlan;
    }

    options.forEach((item) => item.classList.toggle("is-active", item === option));
    tiers.forEach((item) => {
      item.classList.toggle("is-active", item === selectedTier);
      item.setAttribute("aria-pressed", item === selectedTier ? "true" : "false");
    });

    const currentPrice = option.querySelector("[data-buy-current]");
    if (currentPrice && price) {
      currentPrice.textContent = price;
    }

    const totalPrice = option.querySelector(".buy-option-price [data-buy-total]");
    if (totalPrice && total) {
      totalPrice.textContent = total;
    }

    if (cta) {
      cta.disabled = !available;
      cta.textContent = available
        ? cta.dataset.buyAddLabel || "In den Warenkorb legen"
        : cta.dataset.buySoldOutLabel || "Ausverkauft";
    }

    savingsBadges.forEach((badge) => {
      badge.textContent = "";
      badge.hidden = true;
    });

    const savingsBadge = option.querySelector(".buy-savings-badge");
    if (savingsBadge) {
      savingsBadge.textContent = savings;
      savingsBadge.hidden = !savings;
    }

    updateStickyProductCta({ price, label, savings });
  };

  box.addEventListener("click", (event) => {
    const target = event.target.closest("[data-buy-tier], [data-buy-mode-toggle]");
    if (!target || !box.contains(target)) return;
    if (target.closest("[data-buy-disabled]")) return;
    setActivePurchase(target);
  });

  box.addEventListener("change", (event) => {
    const planSelect = event.target.closest("[data-buy-selling-plan-select]");
    if (!planSelect || !box.contains(planSelect)) return;

    const selectedPlan = planSelect.options[planSelect.selectedIndex];
    const subscriptionOption = planSelect.closest("[data-buy-option]");
    const subscriptionToggle = subscriptionOption?.querySelector("[data-buy-mode-toggle]");

    if (subscriptionToggle && selectedPlan) {
      subscriptionToggle.dataset.buySellingPlan = selectedPlan.dataset.buySellingPlan || "";
      subscriptionToggle.dataset.buyVariant = selectedPlan.dataset.buyVariant || "";
      subscriptionToggle.dataset.buyAvailable = selectedPlan.dataset.buyAvailable || "true";
      subscriptionToggle.dataset.buyPrice = selectedPlan.dataset.buyPrice || "";
      subscriptionToggle.dataset.buySavings = selectedPlan.dataset.buySavings || "";
      subscriptionToggle.dataset.buyTotal = selectedPlan.dataset.buyTotal || "";
    }

    if (selectedPlan) {
      setActivePurchase(selectedPlan);
    }
  });

  const activeOption = box.querySelector("[data-buy-option].is-active");
  const activeTier =
    activeOption?.querySelector("[data-buy-tier].is-active") ||
    activeOption?.querySelector("[data-buy-tier]");
  const selected = activeTier || activeOption;

  if (selected) {
    setActivePurchase(selected);
  }
});

const stickyPurchaseMenu = document.querySelector("[data-sticky-purchase-menu]");
const stickyPurchaseToggle = document.querySelector("[data-sticky-purchase-toggle]");
const stickyPurchaseList = document.querySelector("[data-sticky-purchase-list]");
const stickyPurchaseChoices = Array.from(document.querySelectorAll("[data-sticky-purchase-choice]"));

const setStickyPurchaseMenuOpen = (isOpen) => {
  if (!stickyPurchaseToggle || !stickyPurchaseList) return;

  stickyPurchaseToggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
  stickyPurchaseToggle.classList.toggle("is-open", isOpen);
  stickyPurchaseList.hidden = !isOpen;
};

stickyPurchaseToggle?.addEventListener("click", (event) => {
  event.stopPropagation();
  setStickyPurchaseMenuOpen(stickyPurchaseList?.hidden ?? true);
});

stickyPurchaseChoices.forEach((choice) => {
  choice.addEventListener("click", () => {
    if (choice.matches("[data-buy-disabled]")) return;
    const label = choice.dataset.buyLabel;
    const buyBox = document.querySelector("[data-buy-box]");
    const tierTarget = Array.from(buyBox?.querySelectorAll("[data-buy-tier]") || []).find(
      (tier) => tier.dataset.buyLabel === label,
    );
    const modeTarget = Array.from(buyBox?.querySelectorAll("[data-buy-mode-toggle]") || []).find(
      (mode) => mode.dataset.buyLabel === label,
    );

    (tierTarget || modeTarget)?.click();
    setStickyPurchaseMenuOpen(false);
  });
});

document.addEventListener("click", (event) => {
  if (!stickyPurchaseMenu || stickyPurchaseMenu.contains(event.target)) return;
  setStickyPurchaseMenuOpen(false);
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    setStickyPurchaseMenuOpen(false);
  }
});

document.querySelector("[data-sticky-cta]")?.addEventListener("click", () => {
  const summary = document.querySelector(".product-summary");
  const primaryCta = document.querySelector(".product-detail-cta");

  summary?.scrollIntoView({ behavior: prefersReducedMotion ? "auto" : "smooth", block: "center" });

  window.setTimeout(
    () => {
      primaryCta?.click();
    },
    prefersReducedMotion ? 0 : 260,
  );
});

const stickyProductBar = document.querySelector(".product-sticky-cta");
const stickyVisibilityTarget =
  document.querySelector("[data-buy-box]") || document.querySelector(".product-detail-cta");
const stickyEndTarget = document.querySelector("#pdp-final-cta");

if (stickyProductBar && stickyVisibilityTarget) {
  let purchaseTargetIsOutside = false;
  let finalCtaHasBeenReached = false;

  const setStickyVisibility = (isVisible) => {
    stickyProductBar.classList.toggle("is-visible", isVisible);
  };

  const updateStickyVisibility = () => {
    setStickyVisibility(purchaseTargetIsOutside && !finalCtaHasBeenReached);
  };

  if ("IntersectionObserver" in window) {
    const stickyObserver = new IntersectionObserver(
      ([entry]) => {
        purchaseTargetIsOutside = !entry.isIntersecting;
        updateStickyVisibility();
      },
      {
        rootMargin: "0px 0px -5% 0px",
        threshold: 0.05,
      },
    );

    stickyObserver.observe(stickyVisibilityTarget);

    if (stickyEndTarget) {
      const stickyEndObserver = new IntersectionObserver(
        ([entry]) => {
          finalCtaHasBeenReached = entry.isIntersecting || entry.boundingClientRect.top < 0;
          updateStickyVisibility();
        },
        { threshold: 0.02 },
      );

      stickyEndObserver.observe(stickyEndTarget);
    }
  } else {
    const updateStickyVisibilityFromScroll = () => {
      const rect = stickyVisibilityTarget.getBoundingClientRect();
      const finalRect = stickyEndTarget?.getBoundingClientRect();
      purchaseTargetIsOutside = rect.bottom < 0 || rect.top > window.innerHeight;
      finalCtaHasBeenReached = finalRect ? finalRect.top <= window.innerHeight : false;
      updateStickyVisibility();
    };

    updateStickyVisibilityFromScroll();
    window.addEventListener("scroll", updateStickyVisibilityFromScroll, { passive: true });
    window.addEventListener("resize", updateStickyVisibilityFromScroll, { passive: true });
  }
}

const openTargetedDetails = () => {
  const targetId = decodeURIComponent(window.location.hash.slice(1));
  if (!targetId) return;

  const target = document.getElementById(targetId);
  if (target instanceof HTMLDetailsElement) {
    if (target.matches(".faq-page-list details")) {
      document.querySelectorAll(".faq-page-list details").forEach((detail) => {
        if (detail !== target) detail.open = false;
      });
    }
    target.open = true;
  }
};

openTargetedDetails();
window.addEventListener("hashchange", openTargetedDetails);

if ("IntersectionObserver" in window) {
  document.querySelectorAll(".science-accordions, .product-faq-list").forEach((list) => {
    const section = list.closest("section") ?? list;
    let hasEnteredViewport = false;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        hasEnteredViewport = true;
        return;
      }

      if (!hasEnteredViewport) return;

      list.querySelectorAll("details[open]").forEach((detail) => {
        detail.open = false;
      });
    });

    observer.observe(section);
  });
}

const initializedAccordionDetails = new WeakSet();
const accordionTransitionCancels = new WeakMap();

const cancelAccordionTransition = (detail) => {
  accordionTransitionCancels.get(detail)?.();
  accordionTransitionCancels.delete(detail);
};

const finishAccordionTransition = (detail, callback) => {
  cancelAccordionTransition(detail);

  let timeoutId;
  const cleanup = () => {
    detail.removeEventListener("transitionend", onTransitionEnd);
    window.clearTimeout(timeoutId);
  };
  const complete = () => {
    cleanup();
    accordionTransitionCancels.delete(detail);
    callback();
  };
  const onTransitionEnd = (event) => {
    if (event.target !== detail || event.propertyName !== "height") return;
    complete();
  };

  detail.addEventListener("transitionend", onTransitionEnd);
  timeoutId = window.setTimeout(complete, 560);
  accordionTransitionCancels.set(detail, cleanup);
};

const closeAccordionDetail = (detail) => {
  const summary = detail.querySelector(":scope > summary");
  if (!summary || !detail.open) return;

  cancelAccordionTransition(detail);

  if (prefersReducedMotion) {
    detail.open = false;
    detail.classList.remove("is-closing");
    detail.style.height = "";
    return;
  }

  detail.classList.add("is-closing");
  detail.style.height = `${detail.offsetHeight}px`;
  detail.offsetHeight;
  detail.style.height = `${summary.offsetHeight}px`;

  finishAccordionTransition(detail, () => {
    detail.open = false;
    detail.classList.remove("is-closing");
    detail.style.height = "";
  });
};

const openAccordionDetail = (detail, group, exclusive) => {
  const summary = detail.querySelector(":scope > summary");
  const isReversingClose = detail.classList.contains("is-closing");
  if (!summary || (detail.open && !isReversingClose)) return;

  if (exclusive) {
    group.forEach((item) => {
      if (item !== detail) closeAccordionDetail(item);
    });
  }

  const startHeight = detail.open ? detail.offsetHeight : summary.offsetHeight;
  cancelAccordionTransition(detail);
  detail.classList.remove("is-closing");
  detail.open = true;

  if (prefersReducedMotion) {
    detail.style.height = "";
    return;
  }

  detail.style.height = `${startHeight}px`;
  detail.offsetHeight;
  detail.style.height = `${detail.scrollHeight}px`;

  finishAccordionTransition(detail, () => {
    detail.style.height = "";
  });
};

const initializeAccordionGroup = (details, { exclusive = true } = {}) => {
  const group = details.filter(
    (detail) => detail instanceof HTMLDetailsElement && !initializedAccordionDetails.has(detail),
  );
  if (!group.length) return;

  if (exclusive) {
    let hasOpenItem = false;
    group.forEach((detail) => {
      if (!detail.open) return;
      if (hasOpenItem) detail.open = false;
      hasOpenItem = true;
    });
  }

  group.forEach((detail) => {
    const summary = detail.querySelector(":scope > summary");
    if (!summary) return;

    initializedAccordionDetails.add(detail);
    detail.classList.add("is-animated-accordion");

    summary.addEventListener("click", (event) => {
      event.preventDefault();

      if (detail.open && !detail.classList.contains("is-closing")) {
        closeAccordionDetail(detail);
      } else {
        openAccordionDetail(detail, group, exclusive);
      }
    });
  });
};

const faqPageDetails = Array.from(document.querySelectorAll(".faq-page-list > details"));
initializeAccordionGroup(faqPageDetails);

[
  [".product-purchase-accordions", true],
  [".science-accordions", true],
  [".product-faq-list", true],
  [".faq-list", true],
  [".wissen-accordions", true],
  [".wissen-mini-accordions", true],
  [".program-faq-list", false],
].forEach(([selector, exclusive]) => {
  document.querySelectorAll(selector).forEach((list) => {
    initializeAccordionGroup(Array.from(list.querySelectorAll(":scope > details")), { exclusive });
  });
});

document.querySelectorAll("details").forEach((detail) => {
  initializeAccordionGroup([detail], { exclusive: false });
});

const openDeepLinkedDisclosure = () => {
  const hash = window.location.hash;
  if (!hash) return;

  const target = document.getElementById(decodeURIComponent(hash.slice(1)));
  if (!(target instanceof HTMLElement)) return;

  if (target instanceof HTMLDetailsElement) target.open = true;
  target.closest("details")?.setAttribute("open", "");
};

openDeepLinkedDisclosure();
window.addEventListener("hashchange", openDeepLinkedDisclosure);

const getNadChartNumber = (value, fallback = 0) => {
  const text = String(value ?? "");
  const matches = text.match(/\d+(?:[.,]\d+)?/g);
  if (!matches?.length) return fallback;

  const numbers = matches.map((item) => Number(item.replace(",", "."))).filter(Number.isFinite);
  if (!numbers.length) return fallback;

  return numbers.reduce((total, item) => total + item, 0) / numbers.length;
};

const drawNadCurveCanvas = (basisChart) => {
  const canvas = basisChart.querySelector("[data-nad-canvas]");
  if (!canvas) return;

  const context = canvas.getContext("2d");
  const rect = canvas.getBoundingClientRect();
  if (!context || rect.width <= 0 || rect.height <= 0) return;

  const ratio = Math.min(window.devicePixelRatio || 1, 2);
  canvas.width = Math.round(rect.width * ratio);
  canvas.height = Math.round(rect.height * ratio);
  context.setTransform(ratio, 0, 0, ratio, 0, 0);
  context.clearRect(0, 0, rect.width, rect.height);

  const width = rect.width;
  const height = rect.height;
  const xMin = 0;
  const xMax = 100;
  const xScale = (value) => ((Number(value) - xMin) / (xMax - xMin)) * width;
  const yScale = (value) => height - (Number(value) / 100) * height;
  const curveYScale = (value) => Math.min(height - 1, Math.max(1, yScale(value)));

  const rawPoints = Array.from(basisChart.querySelectorAll("[data-age-value][data-nad-value]"))
    .map((point) => ({
      x: getNadChartNumber(point.dataset.ageValue, 0),
      y: getNadChartNumber(point.dataset.nadValue, 0),
    }))
    .filter((point) => Number.isFinite(point.x) && Number.isFinite(point.y))
    .sort((a, b) => a.x - b.x);

  if (!rawPoints.length) return;

  context.lineWidth = 1;
  context.strokeStyle = "rgba(169, 120, 24, 0.18)";
  context.setLineDash([2, 5]);

  [100, 75, 50, 25, 0].forEach((value) => {
    const y = Math.round(yScale(value)) + 0.5;
    context.beginPath();
    context.moveTo(0, y);
    context.lineTo(width, y);
    context.stroke();
  });

  [0, 10, 25, 50, 75, 100].forEach((value) => {
    const x = Math.round(xScale(value)) + 0.5;
    context.beginPath();
    context.moveTo(x, 0);
    context.lineTo(x, height);
    context.stroke();
  });

  context.setLineDash([]);
  context.strokeStyle = "rgba(169, 120, 24, 0.52)";
  context.beginPath();
  context.moveTo(0.5, 0);
  context.lineTo(0.5, height + 0.5);
  context.lineTo(width, height + 0.5);
  context.stroke();

  context.strokeStyle = "#A97818";
  context.lineWidth = 1.8;
  context.lineCap = "round";
  context.lineJoin = "round";
  context.beginPath();

  context.moveTo(xScale(0), curveYScale(100));
  context.lineTo(xScale(25), curveYScale(100));
  context.bezierCurveTo(xScale(31), curveYScale(100), xScale(40), curveYScale(68), xScale(50), curveYScale(50));
  context.bezierCurveTo(xScale(60), curveYScale(40), xScale(72), curveYScale(25), xScale(82), curveYScale(20));
  context.bezierCurveTo(xScale(88), curveYScale(18), xScale(95), curveYScale(16), xScale(100), curveYScale(14));

  context.stroke();

  rawPoints.forEach((point) => {
    const x = xScale(point.x);
    const y = curveYScale(point.y);
    context.beginPath();
    context.arc(x, y, 4.5, 0, Math.PI * 2);
    context.fillStyle = "#FFFFFF";
    context.fill();
    context.lineWidth = 2;
    context.strokeStyle = "#A97818";
    context.stroke();
  });
};

document.querySelectorAll(".basis-chart").forEach((basisChart) => {
  const basisExplainer = basisChart.querySelector(".basis-explainer");
  const basisMetrics = Array.from(basisChart.querySelectorAll(".basis-metric"));
  const defaultBasisExplainer = basisExplainer?.textContent.trim() ?? "";
  const supportsHoverPreview = !basisChart.classList.contains("basis-chart--curve");

  const setActiveMetric = (metric) => {
    basisMetrics.forEach((item) => item.classList.toggle("is-active", item === metric));

    if (basisExplainer && metric.dataset.subtitle) {
      basisExplainer.textContent = metric.dataset.subtitle;
    }
  };

  basisMetrics.forEach((metric) => {
    if (supportsHoverPreview) {
      metric.addEventListener("mouseenter", () => setActiveMetric(metric));
    }
    metric.addEventListener("focus", () => setActiveMetric(metric));
    metric.addEventListener("click", () => setActiveMetric(metric));
  });

  if (supportsHoverPreview) {
    basisChart.addEventListener("mouseleave", () => {
      basisMetrics.forEach((item, index) => item.classList.toggle("is-active", index === 0));

      if (basisExplainer) {
        basisExplainer.textContent = defaultBasisExplainer;
      }
    });
  }

  drawNadCurveCanvas(basisChart);

  if ("ResizeObserver" in window) {
    const observer = new ResizeObserver(() => drawNadCurveCanvas(basisChart));
    observer.observe(basisChart);
  } else {
    window.addEventListener("resize", () => drawNadCurveCanvas(basisChart), { passive: true });
  }
  });

const routineBenefitSlider = document.querySelector("#routine-benefit-slider");
const routineBenefitSlides = Array.from(document.querySelectorAll(".routine-benefit-cards article"));
const routineBenefitPrev = document.querySelector("[data-routine-prev]");
const routineBenefitNext = document.querySelector("[data-routine-next]");

const getClosestSlideIndex = (slider, slides) => {
  if (!slider || slides.length === 0) return 0;

  const firstSlideLeft = slides[0].offsetLeft;

  return slides.reduce(
    (closest, slide, index) => {
      const slideLeft = slide.offsetLeft - firstSlideLeft;
      const distance = Math.abs(slideLeft - slider.scrollLeft);
      return distance < closest.distance ? { index, distance } : closest;
    },
    { index: 0, distance: Infinity },
  ).index;
};

const updateRoutineBenefitControls = () => {
  if (!routineBenefitSlider || routineBenefitSlides.length === 0) return;

  const maxScrollLeft = routineBenefitSlider.scrollWidth - routineBenefitSlider.clientWidth;
  const scrollLeft = routineBenefitSlider.scrollLeft;

  routineBenefitPrev?.toggleAttribute("disabled", scrollLeft <= 2);
  routineBenefitNext?.toggleAttribute("disabled", scrollLeft >= maxScrollLeft - 2);
};

const scrollRoutineBenefitSlider = (direction) => {
  if (!routineBenefitSlider || routineBenefitSlides.length === 0) return;

  const currentIndex = getClosestSlideIndex(routineBenefitSlider, routineBenefitSlides);
  const nextIndex = Math.max(
    0,
    Math.min(routineBenefitSlides.length - 1, currentIndex + direction),
  );
  const nextLeft = routineBenefitSlides[nextIndex].offsetLeft - routineBenefitSlides[0].offsetLeft;

  smoothScrollElementTo(routineBenefitSlider, nextLeft, 760);
};

routineBenefitPrev?.addEventListener("click", () => scrollRoutineBenefitSlider(-1));
routineBenefitNext?.addEventListener("click", () => scrollRoutineBenefitSlider(1));
enableDragScroll(routineBenefitSlider, { onDragEnd: updateRoutineBenefitControls });
routineBenefitSlider?.addEventListener("scroll", updateRoutineBenefitControls, { passive: true });
window.addEventListener("resize", updateRoutineBenefitControls, { passive: true });
updateRoutineBenefitControls();

const ingredientCardSlider = document.querySelector("#ingredient-card-slider");
const ingredientCardSlides = Array.from(
  ingredientCardSlider?.querySelectorAll(".ingredient-showcase-card") ?? [],
);
const ingredientCardPrev = document.querySelector("[data-ingredient-prev]");
const ingredientCardNext = document.querySelector("[data-ingredient-next]");

const updateIngredientSliderControls = () => {
  if (!ingredientCardSlider || ingredientCardSlides.length === 0) return;

  ingredientCardPrev?.removeAttribute("disabled");
  ingredientCardNext?.removeAttribute("disabled");
};

const scrollIngredientSlider = (direction) => {
  if (!ingredientCardSlider || ingredientCardSlides.length === 0) return;

  const firstSlideLeft = ingredientCardSlides[0].offsetLeft;
  const slidePositions = ingredientCardSlides.map((slide) => slide.offsetLeft - firstSlideLeft);
  const scrollLeft = ingredientCardSlider.scrollLeft;
  const threshold = 8;
  const firstLeft = slidePositions[0];
  const lastLeft = slidePositions[slidePositions.length - 1];
  const nextLeft =
    direction > 0
      ? (slidePositions.find((left) => left > scrollLeft + threshold) ?? firstLeft)
      : ([...slidePositions].reverse().find((left) => left < scrollLeft - threshold) ?? lastLeft);

  smoothScrollElementTo(ingredientCardSlider, nextLeft, 760);
};

ingredientCardPrev?.addEventListener("click", () => scrollIngredientSlider(-1));
ingredientCardNext?.addEventListener("click", () => scrollIngredientSlider(1));
enableDragScroll(ingredientCardSlider, { onDragEnd: updateIngredientSliderControls });
ingredientCardSlider?.addEventListener("scroll", updateIngredientSliderControls, { passive: true });
window.addEventListener("resize", updateIngredientSliderControls, { passive: true });
updateIngredientSliderControls();

const qualityCardSlider = document.querySelector("#quality-card-slider");
const qualityCardSlides = Array.from(qualityCardSlider?.querySelectorAll("article") ?? []);
const qualityCardPrev = document.querySelector("[data-quality-prev]");
const qualityCardNext = document.querySelector("[data-quality-next]");

const updateQualitySliderControls = () => {
  if (!qualityCardSlider || qualityCardSlides.length === 0) return;

  qualityCardPrev?.removeAttribute("disabled");
  qualityCardNext?.removeAttribute("disabled");
};

const scrollQualitySlider = (direction) => {
  if (!qualityCardSlider || qualityCardSlides.length === 0) return;

  const firstSlideLeft = qualityCardSlides[0].offsetLeft;
  const slidePositions = qualityCardSlides.map((slide) => slide.offsetLeft - firstSlideLeft);
  const scrollLeft = qualityCardSlider.scrollLeft;
  const threshold = 8;
  const firstLeft = slidePositions[0];
  const lastLeft = slidePositions[slidePositions.length - 1];
  const nextLeft =
    direction > 0
      ? (slidePositions.find((left) => left > scrollLeft + threshold) ?? firstLeft)
      : ([...slidePositions].reverse().find((left) => left < scrollLeft - threshold) ?? lastLeft);

  smoothScrollElementTo(qualityCardSlider, nextLeft, 760);
};

qualityCardPrev?.addEventListener("click", () => scrollQualitySlider(-1));
qualityCardNext?.addEventListener("click", () => scrollQualitySlider(1));
enableDragScroll(qualityCardSlider, { onDragEnd: updateQualitySliderControls });
qualityCardSlider?.addEventListener("scroll", updateQualitySliderControls, { passive: true });
window.addEventListener("resize", updateQualitySliderControls, { passive: true });
updateQualitySliderControls();

const dailyEnergySlider = document.querySelector("#daily-energy-slider");
const dailyEnergyOriginalSlides = Array.from(dailyEnergySlider?.querySelectorAll("article") ?? []);
const dailyEnergyLoopCloneCount = dailyEnergyOriginalSlides.length > 3 ? 3 : 0;

if (dailyEnergySlider && dailyEnergyLoopCloneCount) {
  const beforeFragment = document.createDocumentFragment();
  const afterFragment = document.createDocumentFragment();

  dailyEnergyOriginalSlides.slice(-dailyEnergyLoopCloneCount).forEach((slide) => {
    const clone = slide.cloneNode(true);
    clone.classList.add("is-clone");
    clone.setAttribute("aria-hidden", "true");
    beforeFragment.append(clone);
  });

  dailyEnergyOriginalSlides.slice(0, dailyEnergyLoopCloneCount).forEach((slide) => {
    const clone = slide.cloneNode(true);
    clone.classList.add("is-clone");
    clone.setAttribute("aria-hidden", "true");
    afterFragment.append(clone);
  });

  dailyEnergySlider.prepend(beforeFragment);
  dailyEnergySlider.append(afterFragment);
}

const dailyEnergySlides = Array.from(dailyEnergySlider?.querySelectorAll("article") ?? []);
const dailyEnergyPrev = document.querySelector("[data-daily-energy-prev]");
const dailyEnergyNext = document.querySelector("[data-daily-energy-next]");
let dailyEnergyLoopTimeout = null;
let dailyEnergyActiveIndex = dailyEnergyLoopCloneCount;

const updateDailyEnergyControls = () => {
  if (!dailyEnergySlider || dailyEnergySlides.length === 0) return;

  dailyEnergyPrev?.removeAttribute("disabled");
  dailyEnergyNext?.removeAttribute("disabled");
};

const getDailyEnergySlidePositions = () => {
  const firstSlideLeft = dailyEnergySlides[0].offsetLeft;
  return dailyEnergySlides.map((slide) => slide.offsetLeft - firstSlideLeft);
};

const setDailyEnergyPosition = (index, behavior = "auto") => {
  if (!dailyEnergySlider || dailyEnergySlides.length === 0) return;

  const slidePositions = getDailyEnergySlidePositions();
  const nextLeft = slidePositions[index] ?? 0;

  if (behavior === "smooth") {
    smoothScrollElementTo(dailyEnergySlider, nextLeft, 620);
    return;
  }

  const runningAnimation = activeScrollAnimations.get(dailyEnergySlider);

  if (runningAnimation) {
    runningAnimation.cancelled = true;
    cancelAnimationFrame(runningAnimation.frameId);
    activeScrollAnimations.delete(dailyEnergySlider);
  }

  dailyEnergySlider.classList.add("is-programmatic-scroll");
  dailyEnergySlider.scrollLeft = nextLeft;

  requestAnimationFrame(() => {
    if (!activeScrollAnimations.has(dailyEnergySlider)) {
      dailyEnergySlider.classList.remove("is-programmatic-scroll");
    }
  });
};

const normalizeDailyEnergyIndex = (index) => {
  if (!dailyEnergyLoopCloneCount) {
    return Math.max(0, Math.min(dailyEnergySlides.length - 1, index));
  }

  const originalCount = dailyEnergyOriginalSlides.length;

  if (index >= originalCount + dailyEnergyLoopCloneCount) {
    return dailyEnergyLoopCloneCount + ((index - dailyEnergyLoopCloneCount) % originalCount);
  }

  if (index < dailyEnergyLoopCloneCount) {
    return dailyEnergyLoopCloneCount + originalCount - (dailyEnergyLoopCloneCount - index);
  }

  return index;
};

const scrollDailyEnergySlider = (direction) => {
  if (!dailyEnergySlider || dailyEnergySlides.length === 0) return;

  window.clearTimeout(dailyEnergyLoopTimeout);

  const targetIndex = normalizeDailyEnergyIndex(dailyEnergyActiveIndex + direction);
  const visibleTargetIndex = dailyEnergyActiveIndex + direction;
  const boundedTargetIndex = Math.max(0, Math.min(dailyEnergySlides.length - 1, visibleTargetIndex));

  setDailyEnergyPosition(boundedTargetIndex, prefersReducedMotion ? "auto" : "smooth");

  dailyEnergyLoopTimeout = window.setTimeout(
    () => {
      dailyEnergyActiveIndex = targetIndex;

      if (targetIndex !== boundedTargetIndex) {
        setDailyEnergyPosition(targetIndex, "auto");
      }
    },
    prefersReducedMotion ? 0 : 700,
  );
};

const resetDailyEnergyLoop = () => {
  if (!dailyEnergySlider || !dailyEnergyLoopCloneCount || dailyEnergySlides.length === 0) return;

  requestAnimationFrame(() => {
    dailyEnergyActiveIndex = dailyEnergyLoopCloneCount;
    setDailyEnergyPosition(dailyEnergyActiveIndex, "auto");
  });
};

resetDailyEnergyLoop();

window.addEventListener(
  "resize",
  () => {
    window.clearTimeout(dailyEnergyLoopTimeout);
    resetDailyEnergyLoop();
  },
  { passive: true },
);

dailyEnergyPrev?.addEventListener("click", () => scrollDailyEnergySlider(-1));
dailyEnergyNext?.addEventListener("click", () => scrollDailyEnergySlider(1));
enableDragScroll(dailyEnergySlider, {
  onDragEnd: () => {
    dailyEnergyActiveIndex = getClosestSlideIndex(dailyEnergySlider, dailyEnergySlides);
    updateDailyEnergyControls();
  },
});
dailyEnergySlider?.addEventListener("scroll", updateDailyEnergyControls, { passive: true });
window.addEventListener("resize", updateDailyEnergyControls, { passive: true });
updateDailyEnergyControls();

document.querySelectorAll("[data-product-reorder-disclosure]").forEach((disclosure) => {
  const mobileQuery = window.matchMedia("(max-width: 760px)");
  let wasMobile = null;

  const syncProductReorderDisclosure = () => {
    const isMobile = mobileQuery.matches;

    if (isMobile && wasMobile !== true) {
      disclosure.open = false;
    }

    if (!isMobile) {
      disclosure.open = true;
    }

    wasMobile = isMobile;
  };

  if (typeof mobileQuery.addEventListener === "function") {
    mobileQuery.addEventListener("change", syncProductReorderDisclosure);
  } else {
    mobileQuery.addListener(syncProductReorderDisclosure);
  }

  syncProductReorderDisclosure();
});

document.querySelectorAll("[data-product-variant-card]").forEach((card) => {
  const triggers = Array.from(card.querySelectorAll("[data-product-variant-trigger]"));
  const mediaItems = Array.from(card.querySelectorAll("[data-product-variant-media]"));
  const contentItems = Array.from(card.querySelectorAll("[data-product-variant-content]"));
  const price = card.querySelector("[data-product-variant-price]");
  const buyLink = card.querySelector("[data-product-variant-link]");

  const setProductVariant = (variantId) => {
    const activeTrigger =
      triggers.find((trigger) => trigger.dataset.productVariantTrigger === variantId) ?? triggers[0];

    if (!activeTrigger) return;

    triggers.forEach((trigger) => {
      const isActive = trigger === activeTrigger;
      trigger.classList.toggle("is-active", isActive);
      trigger.setAttribute("aria-selected", String(isActive));
    });

    mediaItems.forEach((item) => {
      const isActive = item.dataset.productVariantMedia === activeTrigger.dataset.productVariantTrigger;
      item.classList.toggle("is-active", isActive);
      item.hidden = !isActive;
    });

    contentItems.forEach((item) => {
      const isActive = item.dataset.productVariantContent === activeTrigger.dataset.productVariantTrigger;
      item.classList.toggle("is-active", isActive);
      item.hidden = !isActive;
    });

    if (price && activeTrigger.dataset.variantPrice) {
      price.textContent = activeTrigger.dataset.variantPrice;
    }

    if (buyLink && activeTrigger.dataset.variantLink) {
      buyLink.href = activeTrigger.dataset.variantLink;
    }
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => setProductVariant(trigger.dataset.productVariantTrigger));
  });

  setProductVariant(triggers.find((trigger) => trigger.classList.contains("is-active"))?.dataset.productVariantTrigger);
});

document.querySelectorAll("[data-energy-comparison]").forEach((comparison) => {
  const range = comparison.querySelector("[data-energy-comparison-range]");
  if (!range) return;

  const updateComparison = () => {
    comparison.style.setProperty("--energy-split", `${range.value}%`);
  };

  range.addEventListener("input", updateComparison);
  updateComparison();
});

document.querySelectorAll("[data-wissen-process-slider]").forEach((slider) => {
  enableDragScroll(slider);
});

document.querySelectorAll("[data-wissen-function-slider]").forEach((slider) => {
  enableDragScroll(slider);
});

})();
const initializeSealSubscriptionPage = () => {
  const sealSubscriptionPage = document.querySelector("[data-seal-subscriptions-list-page]");
  if (!sealSubscriptionPage) return;

  const sealSubscriptionHeading = sealSubscriptionPage.querySelector("[data-seal-your-subscriptions-text]");
  const sealNotLoggedIn = sealSubscriptionPage.querySelector(".seal-not-logged-in");

  if (sealSubscriptionHeading && sealSubscriptionHeading.textContent.trim() !== "Deine Abonnements") {
    sealSubscriptionHeading.textContent = "Deine Abonnements";
  }

  if (sealNotLoggedIn && !sealNotLoggedIn.querySelector(".seal-niucell-login-card")) {
    sealNotLoggedIn.innerHTML = `
      <div class="seal-niucell-login-card">
        <strong>Melde dich an, um dein Abo zu verwalten.</strong>
        <span>Hier kannst du deinen Lieferrhythmus anpassen, Lieferungen pausieren oder überspringen und deine Angaben bearbeiten.</span>
        <a class="seal-niucell-login" href="/account">Jetzt anmelden</a>
      </div>
    `;
  }

};

const sealSubscriptionObserver = new MutationObserver(initializeSealSubscriptionPage);
sealSubscriptionObserver.observe(document.documentElement, { childList: true, subtree: true });
window.setTimeout(() => sealSubscriptionObserver.disconnect(), 8000);

initializeSealSubscriptionPage();
window.addEventListener("load", initializeSealSubscriptionPage, { once: true });
// Match the customer-facing product name in Judge.me's dynamically rendered form.
(() => {
  if (!document.body.classList.contains('is-product-page')) return;
  const original = 'NiuCell Zellenergie-System (Bundle)';
  const displayName = 'NiuCell Zellenergie-System';
  const modalSelector = '.jdgm-write-review-modal';
  const normalizeReviewName = () => {
    document.querySelectorAll(modalSelector).forEach((modal) => {
      modal.querySelectorAll('.jdgm-write-review-modal__product-title, .jdgm-write-review-modal__status').forEach((node) => {
        if (node.textContent.trim() === original) node.textContent = displayName;
      });
      modal.querySelectorAll('.jdgm-write-review-modal__product-image img').forEach((image) => {
        if (image.alt === original) image.alt = displayName;
      });
    });
  };
  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => {
      const target = mutation.target.nodeType === Node.ELEMENT_NODE ? mutation.target : mutation.target.parentElement;
      return target?.closest(modalSelector) || [...mutation.addedNodes].some((node) =>
        node.nodeType === Node.ELEMENT_NODE && (node.matches(modalSelector) || node.querySelector(modalSelector))
      );
    })) normalizeReviewName();
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
  normalizeReviewName();
})();


// Keep the native consent choices accessible on the dedicated cookie settings page.
(() => {
  if (!window.Shopify || /\/pages\/cookie-einstellungen\/?$/.test(window.location.pathname)) return;

  const hideReopenWidget = () => {
    const shadowRoot = document.querySelector('pandectes-cmp')?.shadowRoot;
    if (!shadowRoot) return false;
    if (!shadowRoot.querySelector('#niucell-cookie-widget-scope')) {
      const style = document.createElement('style');
      style.id = 'niucell-cookie-widget-scope';
      // Hide only the floating reopen control; the initial consent dialog stays available.
      style.textContent = 'button.widget[aria-haspopup="dialog"] { display: none !important; }';
      shadowRoot.append(style);
    }
    return true;
  };

  if (hideReopenWidget()) return;
  const timer = window.setInterval(() => {
    if (hideReopenWidget()) window.clearInterval(timer);
  }, 250);
  window.setTimeout(() => window.clearInterval(timer), 20000);
})();
